import type { CreateOptions, Span } from '@wiztime/core';

/**
 * What a drag that comes from outside the lane (a quick-mark tile, 2026-10c §2) needs to know
 * about the lane under the pointer: its personal date, the creation options and the spans of the
 * blocks that are obstacles. Lanes register themselves while mounted; the DOM carries only the
 * date (`data-date`), never the block data.
 */
export interface LaneDropTarget {
  readonly date: string;
  readonly options: CreateOptions;
  readonly obstacles: readonly Span[];
  /** False while the lane's blocks are loading or failed to load, or an overlay of the day page is open: nothing may be dropped. */
  readonly ready: boolean;
}

const targets = new WeakMap<Element, () => LaneDropTarget | null>();

/** Register `lane`; `read` returns the lane's current target. Returns the unregister function. */
export function registerLaneDropTarget(lane: Element, read: () => LaneDropTarget | null): () => void {
  targets.set(lane, read);
  return () => {
    if (targets.get(lane) === read) targets.delete(lane);
  };
}

export function laneDropTargetOf(lane: Element): LaneDropTarget | null {
  return targets.get(lane)?.() ?? null;
}
